import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Experience extends Component {
  render() {
    return(
      <Grid>
        <Cell col={4}>
          <p>{this.props.startYear} - {this.props.endYear}</p>
        </Cell>
        <Cell col={8}>
          <h4 style={{marginTop:'0px'}}>{this.props.jobName}</h4>
          <p><h6><u>{this.props.school}</u></h6></p>
          <p>
          {this.props.description1}<br />
          {this.props.description2}<br />
          {this.props.description3}<br />
          {this.props.description4}<br />
          </p>
          <p><h6><u>{this.props.school2}</u></h6></p>
          <p>
          {this.props.description5}<br />
          {this.props.description6}<br />
          {this.props.description7}<br />
          {this.props.description8}<br />
          {this.props.description9}<br />
          {this.props.description10}<br />
          </p>
        </Cell>
      </Grid>
    )
  }
}

export default Experience;
